var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.color + '_svg',style:(_vm.styling),attrs:{"src":_vm.iconName,"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }